import { Carousel } from "react-bootstrap"

export function EthirdGallery() {
    return (
        <section className="thirdGallery">
            <Carousel>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/thirdGallery/img19.jpg"
                        alt="First slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="/images/thirdGallery/img20.jpg"
                        alt="First slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="../images/thirdGallery/img12.jpeg"
                        alt="First slide"
                    />
                </Carousel.Item>

                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="../images/thirdGallery/img13.jpeg"
                        alt="Second slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="../images/thirdGallery/img14.jpeg"
                        alt="third slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="../images/thirdGallery/img15.jpeg"
                        alt="fourth slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="../images/thirdGallery/img16.jpeg"
                        alt="fifth slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="../images/thirdGallery/img17.jpeg"
                        alt="sixth slide"
                    />
                </Carousel.Item>
            </Carousel>
        </section>
    )
}